import type { Address } from '@root/entities/address/Address'

export const knownPlatforms = [
  'Binance',
  'Binance US',
  'Bithumb',
  'BitMart',
  'Bitfinex',
  'Bitget',
  'Bitstamp',
  'Bybit',
  'CoinEx',
  'Coinbase',
  'Cryptocom',
  'FalconX',
  'Gate',
  'Gemini',
  'Huobi',
  'Kraken',
  'KuCoin',
  'LBank',
  'MEXC',
  'OKX',
  'Poloniex',
  'Revolut',
  'Upbit',
  'XT',
  'FixedFloat',
  'Stake',
  'Changelly',
  'ChangeNow',
] as const

export type KnownPlatform = (typeof knownPlatforms)[number]

export const KNOWN_ADDRESS_MAP: Record<string, KnownPlatform> = {
  '2ojv9BAiHUrvsm9gxDe7fJSzbNZSJcxZvf8dqmWGHG8S': 'Binance',
  '3gd3dqgtJ4jWfBfLYTX67DALFetjc5iS72sCgRhCkW2u': 'Binance',
  '3yFwqXBfZY4jBVUafQ1YEXw189y2dN3V5KQq9uzBDy1E': 'Binance',
  '5tzFkiKscXHK5ZXCGbXZxdw7gTjjD1mBwuoFbhUvuAi9': 'Binance',
  '6QJzieMYfp7yr3EdrePaQoG3Ghxs2wM98xSLRu8Xh56U': 'Binance',
  '9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM': 'Binance',
  GBrURzmtWujJRTA3Bkvo7ZgWuZYLMMwPCwre7BejJXnK: 'Binance',
  H8BgJgae6qhMtf7BM2JtddywSQt11WdxHHxkGLNX5hss: 'Binance',
  '53unSgGWqEWANcPYRF35B2Bgf8BkszUtcccKiXwGGLyr': 'Binance US',
  '3RgFXirEPVEqpuoCpz4wbwc2hv2efTvQHLVddthG5n79': 'Bithumb',
  '8Mm46CsqxiyAputDUp2cXHg41HE3BfynTeMBDwzrMZQH': 'Bithumb',
  '8vUsFSgyoDgXWdBBjST6Kny3feT2UPEMuEzY2WCRgLtE': 'Bithumb',
  ANUBao2a6xATKoNdFrnDADkjVYpcmLVcPp978RwhkJxf: 'Bithumb',
  EqfdXQTL9r8yzjgeTx3nceJBxH3gAMBjiQrUzsf6oRhx: 'Bithumb',
  GCtXCKbCKWudrAsbrHtd2ngMgrSmGZGjoaYRtzPEF3Lv: 'Bithumb',
  H13inzihSqSgfhHrGXNcrhMPzZmp73Mjs1tu8PrnFN7K: 'Bithumb',
  CgANddXc7FKSsdLSdFv67X8faZqQaRTeLMXkAVANkZD4: 'BitMart',
  FxteHmLwG9nk1eL4pjNve3Eub2goGkkz6g6TbvdmW46a: 'Bitfinex',
  '7TWnq4WeYcwQWBCwKeEX2Q9xqVtthPGkB7adNvueuVuh': 'Bitget',
  A77HErqtfN1hLLpvZ9pCtu66FEtM8BveoaKbbMoZ4RiR: 'Bitget',
  DTNnXBh7JcKTzfWbqcuNYaYBQXS2fWWoXEdJ5iyNwvFX: 'Bitstamp',
  HBxZShcE86UMmF93KUM8eWJKqeEXi5cqWCLYLMMhqMYm: 'Bitstamp',
  '2qo8jvuc49pFmTjmUHLiARSV6ppPTaE7gw27ZJ6DnNZy': 'Bybit',
  '5LZkATrLwHYCQj2YuVbjjgsDZzBk6YfL4pFQRJmtboT2': 'Bybit',
  '7cAui6ADtxLnpRr2wYvwJWTkzwgmVF2LYKnjKTLx4xR8': 'Bybit',
  AC5RDfQFmDS1deWZos921JfqscXdByf8BKHs5ACWjtW2: 'Bybit',
  iGdFcQoyR2MwbXMHQskhmNsqddZ6rinsipHc4TNSdwu: 'Bybit',
  D5jx4wmxuPz18hqmgpCMLGVq3uSksCafCp5xjVe1nw8p: 'CoinEx',
  '4NyK1AdJBNbgaJ9EsKz3J4rfeHsuYdjkTPg3JaNdLeFw': 'Coinbase',
  '5g7yNHyGLJ7fiQ9SN9mf47opDnMjc585kqXWt6d7aBWs': 'Coinbase',
  D89hHJT5Aqyx1trP6EnGY9jJUB3whgnq3aUvvCqedvzf: 'Coinbase',
  DPqsobysNf5iA9w7zrQM8HLzCKZEDMkZsWbiidsAt1xo: 'Coinbase',
  FpwQQhQQoEaVu3WU2qZMfF1hx48YyfwsLoRgXG83E99Q: 'Coinbase',
  GCRJD52pGwcCSs4oswYxTBCPatxY1P6WpxCC9R9zty6r: 'Coinbase',
  GJRs4FwHtemZ5ZE9x3FNvJ8TMwitKTh21yxdRPqn7npE: 'Coinbase',
  '6FEVkH17P9y8Q9aCkDdPcMDjvj7SVxrTETaYEm8f51Jy': 'Cryptocom',
  AobVSwdW9BbpMdJvTqeCN4hPAmh4rHm7vwLnQ5ATSyrS: 'Cryptocom',
  AgsYPSd9jQZEpbTMsvBWKdiAux3eyghdSY355QVHH9Hs: 'FalconX',
  u6PJ8DtQuPFnfmwHbGFULQ4u4EgjDiyYKjVEsynXq2w: 'Gate',
  bazxfWH6Vu2FncaSKc3kkgvyCuPwyFpx4ryZPcNiG7x: 'Gemini',
  '88xTWZMeKfiTgbfEmPLdsUCQcZinwUfk25EBQZ21XMAZ': 'Huobi',
  '6LY1JzAFVZsP2a2xKrtU6znQMQ5h4i7tocWdgrkZzkzF': 'Kraken',
  CDhUgGEiUxx1aTbnoiSAKcmBhnGUFRQ6AMzuLQRD5VFZ: 'Kraken',
  '6BhBoBB47wSGjK5uzcGWNcTf2oNRPQNuv6GVdkNyj9PB': 'KuCoin',
  AGVhmrhDi3RKLu9nxnRqp3CUpaG3SVeYXWkWcygHAk8N: 'KuCoin',
  BmFdpraQhkiDQE6SnfG5omcA1VwzqfXrwtNYBwWTymy6: 'KuCoin',
  DBmae92YTQKLsNzXcPscxiwPqMcz9stQr2prB5ZCAHPd: 'KuCoin',
  HVh6wHNBAsG3pq1Bj5oCzRjoWKVogEDHwUHkRz3ekFgt: 'KuCoin',
  '8s9j5qUtuE9PGA5s7QeAXEh5oc2UGr71pmJXgyiZMHkt': 'LBank',
  '5PAhQiYdLBd6SVdjzBQDxUAEFyDdF5ExNPQfcscnPRj5': 'MEXC',
  ASTyfSima4LLAdDgoFGkgqoKowG1LZFDr9fAQrg7iaJZ: 'MEXC',
  '5VCwKtCXgCJ6kit5FybXjvriW3xELsFDhYrPSqtJNmcD': 'OKX',
  AEZoku1fLfUz5JYJ3kJ5YVdf3QT1T4RwdggGbuR8Eakd: 'OKX',
  C68a6RCGLiPskbPYtAcsCjhG8tfTWYcoB4JjCrXFdqyo: 'OKX',
  is6MTRHEgyFLNTfYcuV4QBWLjrZBfmhVNYR6ccgr8KV: 'OKX',
  '7Ci23i82UMa8RpfVbdMjTytiDi2VoZS8uLyHhZBV2Qy7': 'Poloniex',
  '5z7gxL5u4jCW9D6acu28LEw4RKTiBSG1EmXbtCX7efg2': 'Revolut',
  FH9iLV5Z8EUEDMnW6CzUPkpDhWJCsHqJ5N4W23njNsUo: 'Upbit',
  '41uCv6a1JPwZT4pDAN4AGvPosHVx2ndkNFEFgKLzd5wx': 'XT',
  '5ndLnEYqSFiA5yUFHo6LVZ1eWc6Rhh11K5CfJNkoHEPs': 'FixedFloat',
  G9X7F4JzLzbSGMCndiBdWNi5YzZZakmtkdwq7xS3Q3FE: 'Stake',
  DQ5JWbJyWdJeyBxZuuyu36sUBud6L6wo3aN1QC1bRmsR: 'Changelly',
  G2YxRa6wt1qePMwfJzdXZG62ej4qaTC7YURzuh2Lwd3t: 'ChangeNow',
}

export const tryGetKnownPlatform = (
  address: Address,
): KnownPlatform | undefined => {
  return KNOWN_ADDRESS_MAP[address]
}

export const labelOf = (knownPlatform: KnownPlatform): string => {
  return knownPlatform
}
